function preposFixStr(str, predlozky, spojenia, units) {
  var default_predlozky = [
    'a', 'až', 'i', 'o', 'v', 'vo', 'z', 'zo', 'od', 'do', 'k', 'ku', 'u', 's', 'so', 'bez', 'cez', 'pre',
    'pred', 'po', 'pri', 'na', 'nad', 'pod', 'skrz', 'za'
  ]
  var default_spojenia = ['hlavné jedlo', 'nie je', 'de luxe']
  var default_units = ['cm', 'm', 'km', 'l', 'ml', 'g', 'kg']

  if (typeof predlozky === 'function') predlozky = predlozky(default_predlozky)
  if (typeof spojenia === 'function') spojenia = spojenia(default_spojenia)
  if (typeof units === 'function') units = units(default_units)

  predlozky = predlozky || default_predlozky
  spojenia = spojenia || default_spojenia
  units = units || default_units

  if (!predlozky.length && !spojenia.length && !units.length) {
    return str
  }

  var RE_whitespaces = new RegExp(' ', 'g')
  var RE_rtrim = new RegExp('\\s+$')
  var RE_group = {
    predlozky: predlozky.length ? '((^|\\s|\\()(' + predlozky.join('|') + ')\\s)' : '',
    spojenia: spojenia.length ? '(' + spojenia.join('|') + ')' : '',
    units: units.length ? '(\\d\\s(' + units.join('|') + '))' : '',
    count: '\\d+\\.?\\s\\w'
  }

  var nbsp = '\xa0'

  var rexp = {
    all: (function () {
      var groups = []
      if (RE_group.predlozky) groups.push(RE_group.predlozky)
      if (RE_group.spojenia) groups.push(RE_group.spojenia)
      if (RE_group.units) groups.push(RE_group.units)
      if (RE_group.count) groups.push(RE_group.count)
      return new RegExp(groups.join('|'), 'gi')
    }()),
    predlozky: new RegExp(RE_group.predlozky, 'i'),
    spojenia: new RegExp(RE_group.spojenia, 'i'),
    count: new RegExp(RE_group.count, 'i'),
  }

  var preposReplace = function (str) {
    if (RE_group.predlozky && str.match(rexp.predlozky)) {
      return str.replace(RE_rtrim, '') + nbsp
    }

    if (RE_group.spojenia && str.match(rexp.spojenia)) {
      return str.replace(RE_whitespaces, nbsp)
    }

    if (RE_group.count && str.match(rexp.count)) {
      return str.replace(RE_whitespaces, nbsp)
    }

    // unit found
    return str.replace(' ', nbsp)
  }

  return str.replace(rexp.all, preposReplace)
}

function preposFixEl(el, predlozky, spojenia, units) {
  if (!document.createTreeWalker) {
    return false
  }

  var exceptions = ['script', 'style', 'pre']
  var t_start, n, walk, text, originalText

  function isDescendantOfTags(child, tagNames) {
    var tagNamesArr = [].concat(tagNames)
    var node = child.parentNode;
    while (node != null && node !== window.document) {
      if (tagNamesArr.indexOf(node.tagName.toLowerCase()) >= 0) {
        return true;
      }

      node = node.parentNode;
    }

    return false;
  }

  window.preposTimes = window.preposTimes || []

  t_start = Date.now()
  walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false)

  while ((n = walk.nextNode())) {
    text = n.nodeValue

    if (text.trim().length < 3 || isDescendantOfTags(n, exceptions)) {
      continue
    }

    originalText = text
    text = preposFixStr(text, predlozky, spojenia, units)

    if (originalText !== text) {
      n.nodeValue = text
    }
  }

  window.preposTimes.push({
    el: el,
    time: (Date.now() - t_start) + 'ms'
  })

  return el
}

export {
  preposFixStr,
  preposFixEl,
}



// WEBPACK FOOTER //
// ./src/utils/preposfix.js